<template><div><h1 id="konti" tabindex="-1"><a class="header-anchor" href="#konti"><span>Konti</span></a></h1>
<p>Konti — Definiert Buchhaltungskonten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Tabelle Konti dient der Überprüfung der Dateneingabe und Fakturierung, indem hier sämtliche gültigen Konti eingegeben werden müssen. Das System überwacht dann automatisch die Buchungen für die Schnittstelle Finanzbuchhaltung, indem es das Vorhandensein des Kontos überprüft und validiert.</p>
<p>Pfad: <code v-pre>Buchhaltung → Tabellen → Kontenplan Stammtabellen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Konto</dt>
<dd>Konto</dd>
<dt>Export-Konto</dt>
<dd>Ersatz-Konto für Export</dd>
<dt>Whg</dt>
<dd>Währung</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung des Kontos</dd>
<dt>Kontoart</dt>
<dd>Kontoart</dd>
<dt>Zahlungsarten</dt>
<dd><a class="link" href="ft.refdata.tblzahlungsarten.html" title="Zahlungsarten">Zahlungsarten</a></dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.kontkomb.html" title="Kontenplan">Kontenplan</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.kst.html" title="Kostenstellen">Kostenstellen</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.ktr.html" title="Kostenträger">Kostenträger</RouteLink></p>
</div></template>


